/**
 * Horizontal Product Card - Variant Selector
 * Uses event delegation so it works with dynamically loaded content (AJAX)
 */
(function () {
  // Handle SIZE button click
  document.addEventListener("click", function (event) {
    const sizeButton = event.target.closest("[data-size-button]");
    if (!sizeButton) return;

    // Find the wrapper that contains both the card and the dropdown
    const wrapper = sizeButton.closest("[data-card-wrapper]");
    if (!wrapper) return;

    const dropdown = wrapper.querySelector("[data-dropdown]");
    const select = wrapper.querySelector("[data-variant-select]");
    const addButton = wrapper.querySelector("[data-add-button]");
    const form = wrapper.querySelector("form");
    const variantInput = form
      ? form.querySelector("[data-variant-input]")
      : null;

    // Hide SIZE button, show dropdown and ADD button
    sizeButton.hidden = true;
    sizeButton.setAttribute("aria-expanded", "true");
    dropdown.hidden = false;
    addButton.hidden = false;

    // Set the hidden input to the pre-selected variant and enable ADD button
    if (select && select.value && variantInput) {
      variantInput.value = select.value;
      addButton.disabled = false;
    }

    // Focus the select element
    if (select) select.focus();
  });

  // Handle variant selection change
  document.addEventListener("change", function (event) {
    const select = event.target.closest("[data-variant-select]");
    if (!select) return;

    // Find the wrapper that contains both the card and the dropdown
    const wrapper = select.closest("[data-card-wrapper]");
    if (!wrapper) return;

    const form = wrapper.querySelector("form");
    const variantInput = form
      ? form.querySelector("[data-variant-input]")
      : null;
    const addButton = wrapper.querySelector("[data-add-button]");
    const selectedValue = select.value;

    if (selectedValue && variantInput && addButton) {
      // Update hidden input with selected variant ID
      variantInput.value = selectedValue;

      // Enable ADD button (it's already visible from SIZE click)
      addButton.disabled = false;
    }
  });
})();
